// src/page/auth/LoginPage.js

import LoginModal from "./LoginModal";

export default function LoginPage() {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <LoginModal onLoginSuccess={() => {
                // 로그인 성공하면 메인으로 리다이렉트
                window.location.href = "/";
            }} />
        </div>
    );
}